import PCLayout from "@/views/PC/Layout.vue";
import H5Layout from "@/views/H5/Layout.vue";
import PCEnLayout from "@/views/PC/Enlayout.vue";
import H5EnLayout from "@/views/H5/EnLayout.vue";
export const pcRoutes = [
  {
    path: "/",
    name: "Layout",
    component: PCLayout,
    children: [
      {
        path: "test",
        name: "Test",
        component: () =>
          import(/* webpackChunkName: "pcTest" */ "../views/PC/test.vue"),
      },
      {
        path: "my",
        name: "My",
        component: () =>
          import(/* webpackChunkName: "pcMy" */ "../views/PC/My/index.vue"),
      },
      {
        path: "schedule",
        name: "Schedule",
        component: () =>
          import(
            /* webpackChunkName: "pcSchedule" */ "../views/PC/ScheduleNew.vue"
          ),
      },
      {
        path: "contribute",
        name: "Contribute",
        component: () =>
          import(
            /* webpackChunkName: "pcContribute" */ "../views/PC/Contribute.vue"
          ),
      },
      {
        path: "richtext",
        name: "RichText",
        component: () =>
          import(
            /* webpackChunkName: "pcRichtext" */ "../views/PC/RichText.vue"
          ),
      },
      {
        path: "attachments",
        name: "Attachments",
        component: () =>
          import(
            /* webpackChunkName: "pcAttachments" */ "../views/PC/Attachments.vue"
          ),
      },
      {
        path: "/play",
        name: "Play",
        component: () =>
          import(/* webpackChunkName: "file" */ "../views/Play.vue"),
      },
      {
        path: "agendaPoster",
        name: "AgendaPoster",
        component: () =>
          import(/* webpackChunkName: "file" */ "../views/PC/AgendaPoster.vue"),
      },
    ],
  },
  {
    path: "/sendEmail",
    name: "SendEmail",
    component: () =>
      import(/* webpackChunkName: "file" */ "../views/London/SendEmail.vue"),
  },
  {
    path: "/file",
    name: "File",
    component: () =>
      import(/* webpackChunkName: "file" */ "../views/PC/FileView.vue"),
  },
  {
    path: "/error",
    name: "Error",
    component: () =>
      import(/* webpackChunkName: "file" */ "../views/Error.vue"),
  },
  {
    path: "/dialogue",
    name: "Dialogue",
    redirect: "/dialogue/register",
    children: [
      {
        path: "agenda",
        name: "Agenda",
        component: () =>
          import(/* webpackChunkName: "file" */ "../views/London/Agenda.vue"),
      },
      {
        path: "register",
        name: "Register",
        component: () =>
          import(/* webpackChunkName: "file" */ "../views/London/Register.vue"),
      },
      {
        path: "dinner",
        name: "Dinner",
        component: () =>
          import(/* webpackChunkName: "file" */ "../views/London/Dinner.vue"),
      },
      {
        path: "cancel",
        name: "Cancel",
        component: () =>
          import(/* webpackChunkName: "file" */ "../views/London/Cancel.vue"),
      },
    ],
  },
  {
    path: "/conferenceStatistics",
    name: "ConferenceStatistics",
    component: () =>
      import(
        /* webpackChunkName: "file" */ "../views/ConferenceStatistics.vue"
      ),
  },
  {
    path: "/en",
    name: "EnLayout",
    component: PCEnLayout,
    redirect: "/en/home",
    children: [
      {
        path: "home",
        name: "EnHome",
        meta: {
          isGetConfigEnHome: true,
        },
        component: () =>
          import(/* webpackChunkName: "pcEnHome" */ "../views/PC/EnHome.vue"),
      },
      {
        path: "programme",
        name: "EnProgramme",
        meta: {
          isGetConfigEnHome: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "pcEnProgramme" */ "../views/PC/EnProgramme.vue"
          ),
      },
      {
        path: "contact",
        name: "EnContact",
        meta: {
          isGetConfigEnHome: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "pcEnContact" */ "../views/PC/Encontact.vue"
          ),
      },
    ],
  },
];
export const h5Routes = [
  {
    path: "/",
    name: "Layout",
    component: H5Layout,
    redirect: "/index",
    children: [
      {
        path: "index",
        name: "Index",
        component: () =>
          import(/* webpackChunkName: "h5Index" */ "../views/H5/Index.vue"),
      },
      {
        path: "pay",
        name: "Pay",
        component: () =>
          import(/* webpackChunkName: "h5Pay" */ "../views/H5/PayNew.vue"),
      },
      {
        path: "voucher",
        name: "Voucher",
        component: () =>
          import(
            /* webpackChunkName: "h5Voucher" */ "../views/H5/VoucherNew.vue"
          ),
      },
      {
        path: "schedule",
        name: "Schedule",
        component: () =>
          import(
            /* webpackChunkName: "h5Schedule" */ "../views/H5/ScheduleNew.vue"
          ),
      },
      {
        path: "contribute",
        name: "Contribute",
        component: () =>
          import(
            /* webpackChunkName: "h5Contribute" */ "../views/H5/Contribute.vue"
          ),
      },
      {
        path: "richtext",
        name: "RichText",
        component: () =>
          import(
            /* webpackChunkName: "h5Richtext" */ "../views/H5/RichText.vue"
          ),
      },
      {
        path: "attachments",
        name: "Attachments",
        component: () =>
          import(
            /* webpackChunkName: "h5Attachments" */ "../views/H5/Attachments.vue"
          ),
      },
      {
        path: "play",
        name: "Play",
        component: () =>
          import(/* webpackChunkName: "file" */ "../views/Play.vue"),
      },
      {
        path: "agendaPoster",
        name: "AgendaPoster",
        component: () =>
          import(/* webpackChunkName: "file" */ "../views/H5/AgendaPoster.vue"),
      },
    ],
  },
  {
    path: "/dialogue",
    name: "Dialogue",
    redirect: "/dialogue/register",
    children: [
      {
        path: "agenda",
        name: "Agenda",
        component: () =>
          import(/* webpackChunkName: "file" */ "../views/London/Agenda.vue"),
      },
      {
        path: "register",
        name: "Register",
        component: () =>
          import(/* webpackChunkName: "file" */ "../views/London/Register.vue"),
      },
      {
        path: "dinner",
        name: "Dinner",
        component: () =>
          import(/* webpackChunkName: "file" */ "../views/London/Dinner.vue"),
      },
      {
        path: "cancel",
        name: "Cancel",
        component: () =>
          import(/* webpackChunkName: "file" */ "../views/London/Cancel.vue"),
      },
    ],
  },
  {
    path: "/conferenceStatistics",
    name: "ConferenceStatistics",
    component: () =>
      import(
        /* webpackChunkName: "file" */ "../views/ConferenceStatistics.vue"
      ),
  },
  // 通用大会核销页面
  {
    path: "/writeOffNew",
    name: "WriteOffNew",
    component: () =>
      import(/* webpackChunkName: "file" */ "../views/H5/WriteOff.vue"),
  },
  {
    path: "/file",
    name: "File",
    component: () =>
      import(/* webpackChunkName: "file" */ "../views/H5/FileView.vue"),
  },
  {
    path: "/error",
    name: "Error",
    component: () =>
      import(/* webpackChunkName: "file" */ "../views/Error.vue"),
  },
  /***
   *
   * 脑健康运动会
   *
   ***/
  {
    path: "/sport/:specialId",
    name: "SportIndex", //运动会首页
    component: () => import("../views/H5/NerveSportsMeeting/index.vue"),
    children: [
      {
        path: "",
        name: "SportHome", //首页
        component: () => import("../views/H5/NerveSportsMeeting/Home.vue"),
      },
      {
        path: "science",
        name: "Science", //科普
        component: () => import("../views/H5/NerveSportsMeeting/Science.vue"),
      },
      {
        path: "photowall",
        name: "PhotoWall", //照片墙
        component: () => import("../views/H5/NerveSportsMeeting/PhotoWall.vue"),
      },
    ],
  },
  {
    path: "/sport/myphotowall",
    name: "MyPhotoWall", //我的照片墙
    component: () => import("../views/H5/NerveSportsMeeting/MyPhotoWall.vue"),
  },
  {
    path: "/sport/uploadsuccess",
    name: "UploadSuccess", //上传成功
    component: () => import("../views/H5/NerveSportsMeeting/UploadSuccess.vue"),
  },

  {
    path: "/en",
    name: "EnLayout",
    component: H5EnLayout,
    redirect: "/en/home",
    children: [
      {
        path: "home",
        name: "EnHome",
        meta: {
          isGetConfigEnHome: true,
        },
        component: () =>
          import(/* webpackChunkName: "h5EnHome" */ "../views/H5/EnHome.vue"),
      },
      {
        path: "programme",
        name: "EnProgramme",
        meta: {
          isGetConfigEnHome: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "h5EnProgramme" */ "../views/H5/EnProgramme.vue"
          ),
      },
      {
        path: "contact",
        name: "EnContact",
        meta: {
          isGetConfigEnHome: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "h5EnContact" */ "../views/H5/Encontact.vue"
          ),
      },
    ],
  },
];
